export default "__VITE_ASSET__Dbs5asa9__"